export const MENTORME_APP_STORE_URL =
  'https://apps.apple.com/de/app/mentor-me-ai/id6761291502?l=en-GB';

export const MENTORME_GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=kz.mentorme.mobile&hl=ru';

function buildQrImageUrl(link, size) {
  const data = encodeURIComponent(link);
  return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${data}&margin=8`;
}

export function getAppStoreQrImageUrl(size = 168) {
  return buildQrImageUrl(MENTORME_APP_STORE_URL, size);
}

export function getGooglePlayQrImageUrl(size = 168) {
  return buildQrImageUrl(MENTORME_GOOGLE_PLAY_URL, size);
}
